import {
  setToken as setBusinessIdToken,
  getBusinessId as getStoredBusinessId,
  clearToken as clearBusinessIdToken,
} from './business';

export const DEFAULT_BUSINESS_ID = 'BIZ001';

export const setBusinessId = (businessId: string) => {
  setBusinessIdToken(businessId);
};

export const getBusinessId = () => getStoredBusinessId();

export const clearBusinessId = () => {
  clearBusinessIdToken();
};
